// extracted by mini-css-extract-plugin
export default {"mCard":"RE-z","image":"SE-z","imageNoBackground":"TE-z","imageHasCategory":"UE-z","fullWidth":"VE-z"};